export default __webpack_public_path__ + "static/Persona-Vivian-368073a8b227fcb34fd804a66344e8be.png";